import { QueryClient } from '@tanstack/react-query';

/**
 * Singleton TanStack Query client for the application.
 *
 * This module is a true leaf in the dependency graph — it has no imports from
 * any other local module — so it can be safely imported by any module without
 * risk of circular references:
 *
 *   router.tsx               ──imports──▶  query-client.ts  (leaf)
 *   createAgGridDatasource.ts ──imports──▶  query-client.ts  (leaf)
 *
 * The full acyclic chain across lib/ is:
 *
 *   unauthorized-handler.ts  (leaf)
 *   query-client.ts          (leaf)
 *   api-client.ts   ──imports──▶  unauthorized-handler.ts
 *   router.tsx      ──imports──▶  query-client.ts
 *                   ──imports──▶  unauthorized-handler.ts
 *
 * NOTE: No default `queryFn` is registered here. Every query in the codebase
 * provides its own explicit `queryFn`, so a global default would be unused and
 * misleading. If a query is accidentally written without a `queryFn`, TanStack
 * Query will throw a clear "Missing queryFn" error rather than silently
 * succeeding (or failing) via a hidden default.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5_000,
    },
  },
});
